import React, { FC, lazy, PropsWithChildren, ReactNode, Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useWindowSize } from '../../hooks/CustomHooks';
import css from './ApplicationWrapper.module.scss';

import { Button, ButtonVariant, FaIcon, FaIcons, LayoutGrid, Section, Theme } from '@innovationnorway/component-library';
import { ApplicationCategory } from '../../enums/ApplicationCategory';
import useDevelopmentApplication from '../../hooks/developmentApplication/use-development-application';
import { useUrlApplicationId } from '../../hooks/use-url-application-id';
import { FocusArea } from '../../models';
const Page = lazy(() => import('../../components/Page/Page'));
const ApplicationTitle = lazy(() => import('../../ApplicationShared/ApplicationTitle/ApplicationTitle'));
const ApplicationFooter = lazy(() => import('../../ApplicationShared/ApplicationFooter/ApplicationFooter'));
const ApplicationInfoDevelopment = lazy(
  () => import('../../ApplicationShared/ApplicationInfo/ApplicationInfoDevelopment'),
);
const FormContentWrapper = lazy(() => import('../../components/FormContentWrapper/FormContentWrapper'));
const DevelopmentApplicationMenu = lazy(
  () => import('../../components/Navigation/ApplicationMenu/DevelopmentApplicationMenu'),
);
const CustomPageLoader = lazy(() => import('../../components/LoaderContainer/CustomPageLoader'));

export interface ThemePageWrapperProps {
  footer?: ReactNode;
}
export interface DevelopmentProjectAboutFormFields {
  projectJustification: string;
  goalDescription: string;
  trainingDescription: string;
  educationalOfferingsDescription: string;
  futureClusterValueDescription: string;
  feasibilityStudyMainProjectsDescription: string;
  focusArea: Array<FocusArea>;
  goalId: string;
  innovationLevel: string;
  projectName: string;
  projectStartDate: string;
  projectEndDate: string;
}

const DevelopmentProjectApplication: FC<ThemePageWrapperProps> = ({
  footer,
}: PropsWithChildren<ThemePageWrapperProps>) => {
  const [showMenu, setShowMenu] = useState<boolean>(true);
  const windowSize = useWindowSize();
  const { applicationId } = useUrlApplicationId();
  const { isLoading } = useDevelopmentApplication(applicationId);

  useEffect(() => {
    if (windowSize.width <= 900) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  }, [windowSize]);

  return (
    <Page backgroundGray={true} paddingTop={true}>
      <ApplicationTitle />
      <Section>
        <LayoutGrid>
          <div className={css['application__sub-menu']}>
            <Button
              aria-expanded={showMenu}
              aria-controls="side-nav"
              aria-haspopup="true"
              className={css['application__sub-menu-button-toggle']}
              variant={ButtonVariant.Solid}
              theme={Theme.Neutral}
              onClick={() => {
                setShowMenu(!showMenu);
              }}
            >
              <span className={css['application__sub-menu-button-text']}>
                <span>Skjema meny</span>
              </span>
              <FaIcon name={showMenu ? FaIcons.ChevronUp : FaIcons.ChevronDown} />
            </Button>
            <DevelopmentApplicationMenu hidden={!showMenu} applicationId={applicationId} />
          </div>
          <FormContentWrapper>
            <Suspense fallback={<CustomPageLoader viewportHeight={true} />}>
              {isLoading ? <CustomPageLoader /> : <Outlet />}
            </Suspense>
          </FormContentWrapper>
          <ApplicationInfoDevelopment />
        </LayoutGrid>
      </Section>
      <Section>
        <ApplicationFooter footer={footer} applicationType={ApplicationCategory.DEVELOPMENT} />
      </Section>
    </Page>
  );
};

export default DevelopmentProjectApplication;
